import { render, staticRenderFns } from "./ITable.vue?vue&type=template&id=b5e022ea&"
import script from "./ITable.vue?vue&type=script&lang=js&"
export * from "./ITable.vue?vue&type=script&lang=js&"
import style0 from "./ITable.vue?vue&type=style&index=0&id=b5e022ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports